import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const postSkill = skillData => {
  return dispatch => {
    dispatch({ type: "POST_SKILL_LOADING" });
    api
      .skillPost(skillData)
      .then(resp => {
        if (skillData.skillId) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "AddSkillErrorAlertTitle",
          "Virhe taidon tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_SKILL_SUCCEEDED",
  payload: { skill: data },
});

const postEditSucceeded = data => ({
  type: "POST_SKILL_EDIT_SUCCEEDED",
  payload: { skill: data },
});

const operationFail = () => ({
  type: "POST_SKILL_FAIL"
});